// Internal
import { tokenService } from './token.service';
import { config } from '@/infrastructure';

class UserService {

  public isUserLogged(): boolean {
    return tokenService.getToken() != null;
  }

  async login(username: string, password: string): Promise<any> {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    let response = await fetch(`${config.authUrl}/auth/login`, requestOptions);
    
    let data = await response.json();

    return data;
  }

  async refreshUser(): Promise<any> {

    const token = tokenService.getToken();

    if(!token) {
      return undefined;
    }

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    let response = await fetch(`${config.authUrl}/auth/user`, requestOptions);
    
    let data = await response.json();

    return data;
  }

  logout() {
    // remove user from local storage to log user out
    tokenService.removeToken();
  }

  async handleResponse(response: Response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                this.logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
  }
}

export const userService = new UserService();